// extracted by mini-css-extract-plugin
module.exports = {"load":"load_load__3KcH8"};